export default {
  slug: "toolbox-app",
  code: "TB",
  label: "Toolbox App",
  krakenDir: "Toolbox",
  logoFamily: "jb",
};
